/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import type IntercomMessengerDataController from 'embercom/controllers/apps/app/standalone/deploy/intercom-messenger/data';

export default class IntercomMessengerDataRoute extends Route {
  queryParams = {
    section: {
      refreshModel: false,
    },
  };

  setupController(
    controller: IntercomMessengerDataController,
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.set('section', null);
  }
}
